import ChasingChaat from './pdfs/ChasingChaat.pdf';
import OldHustle from './pdfs/OldHustle.pdf';
import PaperPlanes from './pdfs/PaperPlanes.pdf';

let writing = [
    {
        section: "Published Work",
        pieces: [
            { 
                title: "Waiting to be Cleansed",
                publication: "Sobremesa Magazine, Volume 5: FIRE",
                date: "Feb 2026",
                description: <>This piece explores fire, food, and the complicated ethics of my own vegetarianism, through a slaughtered sheep in Ghana and the rituals of the Hindu temple.</>,
                link: "https://www.sobremesamagazine.com/shop/p/sobremesa-volume-4-z69e4"
            },
            { 
                title: "Framing the Aangan",
                publication: "Awaaz Magazine, Winter 2026 Issue",
                date: "Jan 2026",
                description: <>A piece examining the role of the <i>aangan</i>, or inner courtyard, in Indian popular media, especially how it relates to women's role as cook within the space.</>,
                link: "https://heyzine.com/flip-book/e045dcd43e.html"
            },
        ]
    },
    {
        section: "Obroni Kitchen (My Substack!)",
        pieces: [
            { 
                title: "Blisters",
                date: "Dec 2022",
                description: <>A short creative non-fiction piece about maize, race, and my experiences as a "white man" in rural Ghana.</>,
                link: "https://obronikitchen.substack.com/p/blisters"
            },
        ]
    },
    {
        section: "Cookbooks",
        pieces: [
            { 
                title: "Maa Ke Haath Ka",
                date: "Nov 2025",
                description: <>I envisioned this cookbook as a collaboration between my grandmother and I: her recipes and my kitchen, her words and my camera, her intuition and my precision. Made as a 60th birthday gift for <i>my</i> mother, this cookbook is a snapshot of North Indian homestyle cooking from the hands of <i>her</i> mother.</>,
                link: "https://archive.org/details/maa-ke-haath-ka"
            },
            { 
                title: "Chasing Chaat",
                date: "Dec 2021",
                description: <>A short cookbook made for a South Asian Food Studies class, tracing the trade routes of several ingredients used for <i>chaat</i>, and using my mom's recipes to actualize these histories.</>,
                link: ChasingChaat
            }
        ]
    },
    {
        section: "Comics",
        pieces: [
            {
                title: "Old Hustle",
                date: "May 2020",
                description: "A short comic made as a final project for a Graphic Novels class. This was a joint project, so I worked on the illustration while my partner worked on the narrative and storyboards.",
                link: OldHustle
            },
            {
                title: "Paper Planes",
                date: "Mar 2020",
                description: "A short comic made as a solo mid-term project for a Graphic Novels class.",
                link: PaperPlanes
            }
        ]
    },
];

export default writing;